import { lazy } from 'react'

export const SmoothScrollBar = lazy(() => import('simplebar-react'))
